import React from 'react'
import Colortheme from '../../Theme/Colortheme';
import { messyBorderStyle } from '../../Utils/StyleUtils';

const PlayerCard = props => {
    var divStyle = {
        ...messyBorderStyle("playercard_" + props.player.publicId),
        padding: '5px 15px 5px 10px',
        margin: '10px',
        backgroundColor: '#FFFFFF',
        display: 'flex',
        overflow: 'hidden',
        fontWeight: 'bold',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        boxShadow: `0px 2px 3px 0px ${Colortheme.shadowColor}`,
        WebkitBoxShadow: `0px 2px 3px 0px ${Colortheme.shadowColor}`
    }

    if (props.highlight) {
        divStyle.backgroundColor = '#FFD700'
    }

    return <div style={divStyle}>
        <img src={`${process.env.PUBLIC_URL}/assets/avatars/128/${props.player.avatar}.gif`} className="icon" height={"50px"} alt="" style={{ paddingRight: "10px" }} />
        <div style={{ overflow: 'hidden' }}>{props.player.displayName}</div>
        {props.player.isAdmin && !props.hideAdminIndicator ? <div style={{ fontWeight: 'normal' }}>&nbsp;(Admin)</div> : <div />}
    </div>
}

export default PlayerCard
